import { RoadmapProps } from "@interfaces/uiElementTypes";
import CheckIcon from "@mui/icons-material/Check";

const Roadmap: React.FC<RoadmapProps> = ({
  currentStep,
  totalSteps,
  className,
}) => {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      {Array.from({ length: totalSteps }, (_, index) => {
        const step = index + 1;
        const isCompleted = step < currentStep;
        const isCurrent = step === currentStep;

        return (
          <div
            key={step}
            className={`flex items-center ${step === totalSteps ? "" : "w-full"}`}
          >
            {isCompleted ? (
              <div
                className={`flex h-[1.125rem] w-[1.125rem] shrink-0 transform-gpu items-center justify-center rounded-full border-2 border-primary-500 bg-primary-500 transition-all duration-300 ease-in-out hover:scale-110 hover:shadow-md hover:shadow-primary-200`}
              >
                <CheckIcon
                  sx={{ fontSize: 8 }}
                  className="text-white transition-transform duration-300 ease-in-out"
                />
              </div>
            ) : (
              <div
                className={`flex shrink-0 items-center justify-center rounded-full border-2 bg-gray-100 transition-all duration-300 ease-in-out hover:shadow-sm ${
                  isCurrent
                    ? "h-[1.125rem] w-[1.125rem] border-gray-100 hover:scale-105"
                    : "h-3 w-3 border-gray-200"
                } `}
              >
                <div
                  className={`transition-all duration-300 ease-in-out ${
                    isCurrent
                      ? `h-[0.375rem] w-[0.375rem] animate-pulse rounded-full border-2 border-primary-500 bg-primary-500`
                      : ""
                  } `}
                />
              </div>
            )}
            {step < totalSteps && (
              <div
                className={`h-[0.125rem] w-[85%] shrink-0 transition-all duration-500 ease-in-out ${
                  isCompleted ? "scale-x-100 bg-primary-500" : "bg-gray-200"
                } `}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Roadmap;
